import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { explanationOf, hasChallenge } from '../explanation';

const Chip = ({ children }) => <span className="hia-ack-inline-secret" data-testid="how-secret">{children}</span>;

// Pattern formula: "a digit, then a lowercase letter, then ..." in the page language.
export const formulaText = (classes, formatMessage) => classes
    .map((cls) => formatMessage({ id: `conventionPage.how.class.${cls}` }))
    .join(formatMessage({ id: 'conventionPage.how.class.then' }));

const valuesFor = (values, formatMessage) => {
    const out = { ...values };
    if (typeof values.marker === 'string') out.marker = <Chip>{values.marker}</Chip>;
    if (typeof values.keyword === 'string') out.keyword = <Chip>{values.keyword}</Chip>;
    if (Array.isArray(values.classes)) out.formula = formulaText(values.classes, formatMessage);
    delete out.classes;
    return out;
};

// "How it works": the page's own explanation for this convention (never the raw engine label).
export const HowItWorksSection = ({ variant, parameters, examples, intl }) => {
    const paragraphs = explanationOf(variant, parameters, examples);
    return (
        <section className="hia-ack-card" aria-labelledby="hia-ack-h-how" data-section="how">
            <h2 id="hia-ack-h-how" className="hia-ack-h2"><FormattedMessage id="conventionPage.how.heading" /></h2>
            <div className="hia-ack-rule" data-testid="how-text">
                {paragraphs.map((p) => (
                    <p key={p.id} data-how={p.id}>
                        <FormattedMessage id={p.id} values={valuesFor(p.values, intl.formatMessage)} />
                    </p>
                ))}
            </div>
            {hasChallenge(variant) && (
                <p className="hia-ack-note" data-testid="how-same-display"><FormattedMessage id="conventionPage.how.sameDisplay" /></p>
            )}
        </section>
    );
};

export default injectIntl(HowItWorksSection);
